@if (!showMsalRedirect) {
<div class="blank-layout-container justify-content-center">
  <div class="position-relative row w-100 h-100">
    <div class="col-lg-4">
      <div class="d-flex align-items-start align-items-lg-center justify-content-center h-100">
        <div class="row justify-content-center w-100 h-100 align-items-center">
          <div class="col-lg-9 max-width-form">
            <a [routerLink]="['/']">
              <img src="./assets/images/logos/logo-icon.svg" class="align-middle m-2" alt="logo" />
            </a>
            <h4 class="f-w-700 f-s-24 m-t-24 m-b-8">Get Started with your Dashboard</h4>
            <span class="f-s-14 d-block mat-body-1 m-t-8">Sign in to your account</span>

            <div class="row m-t-24">
              <div class="col-12">
                <button mat-stroked-button class="w-100" (click)="login()">
                  <div class="d-flex align-items-center">
                    <img src="https://cdn.worldvectorlogo.com/logos/microsoft-5.svg" alt="microsoft" width="16"
                      class="m-r-8" />
                    Sign In With Microsoft AD
                  </div>
                </button>
              </div>
            </div>

            <span class="f-s-14 d-block mat-body-1 m-t-20">
              By signing in, you agree to our <a href="#">Terms of Service</a> and
              <a [routerLink]="['/authentication/privacy-policy']">Privacy Policy</a>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-8 position-relative overflow-hidden bg-dark-200 d-none d-lg-block">
      <div class="circle-top"></div>
      <div>
        <img src="/assets/images/logos/logo-icon.svg" class="circle-bottom" alt="Logo-Dark" />
      </div>
      <div class="d-flex align-items-center z-1 position-relative h-n80">
        <div class="row justify-content-center w-100">
          <div class="col-lg-6">
            <h2 class="text-white f-s-40 m-b-16 lh-base">
              Welcome to <br />
              ArturPro
            </h2>
            <span class="op-75 f-s-16 text-white d-block m-b-16">The culture of Aether Financial Services is based on the performance<br>
              of the services offered and the satisfaction <br>
              of our customers while emphasizing our strengths <br>
              of a job well done by an invested team.
            </span>
            <button mat-flat-button color="primary">Learn More</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}

@if (showMsalRedirect) {
<app-msal-redirect></app-msal-redirect>
}